import DatabaseAdapter from 'src/firebase/db/DatabaseAdapter';

/**
 * name: string | 商品名
 * price: number | 価格
 */

export const shopBagInitialEntity = {
  id: '',
  name: '',
  price: 0,
  created_at: {} as firebase.firestore.FieldValue,
  updated_at: {} as firebase.firestore.FieldValue,
};
export type ShopBagEntity = typeof shopBagInitialEntity;
export const shopBagEntityKeys = (Object.keys(
  shopBagInitialEntity,
) as unknown) as (keyof ShopBagEntity)[];

class ShopBagsDB extends DatabaseAdapter {
  constructor(props: any) {
    super(props);
    this.setSchemaKeys(shopBagEntityKeys);
  }
}

export default new ShopBagsDB({
  schema: '',
});
